import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      title: 'Replace Multiple Tools',
      description: 'Consolidate ClickFunnels, Mailchimp, Calendly, ActiveCampaign, and more into one powerful platform.',
    },
    {
      title: 'Scale Without Limits',
      description: 'Unlimited users, contacts, and sub-accounts—perfect for agencies and growing businesses.',
    },
    {
      title: 'Boost Revenue Streams',
      description: 'Create membership sites, resell as white-label SaaS, and monetize communication services.',
    },
    {
      title: 'Save Time with Automation',
      description: 'Automate repetitive tasks and focus on what matters—growing your business and serving clients.',
    },
    {
      title: 'Enhance Client Experience',
      description: 'Deliver seamless multi-channel communication and professional branded experiences.',
    },
    {
      title: 'Data-Driven Decisions',
      description: 'Access comprehensive analytics and insights to optimize campaigns and maximize ROI.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#0a2e2e] via-[#1a4d4d] to-[#0a2e2e] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#8b956d]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-[#8b956d]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#c5c9b8] mb-6 font-['Cinzel']">
              Why Choose Excalibur?
            </h2>
            <p className="text-lg text-[#b5bca0] mb-8 leading-relaxed">
              Built on the proven GoHighLevel platform, Excalibur CRM delivers enterprise-level capabilities with the flexibility and control your business demands.
            </p>
            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 group"
                >
                  <div className="flex-shrink-0 w-8 h-8 bg-[#8b956d]/20 rounded-full flex items-center justify-center group-hover:bg-[#8b956d]/30 transition-colors duration-300">
                    <CheckCircle2 className="w-5 h-5 text-[#8b956d]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#c5c9b8] mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-[#b5bca0] leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#1a4d4d]/40 backdrop-blur-sm p-8 rounded-xl border border-[#8b956d]/20 hover:border-[#8b956d]/50 transition-all duration-300 hover:scale-105">
              <div className="text-5xl font-bold text-[#8b956d] mb-2 font-['Cinzel']">∞</div>
              <div className="text-lg text-[#c5c9b8] font-semibold">Unlimited</div>
              <div className="text-sm text-[#b5bca0]">Contacts & Accounts</div>
            </div>
            <div className="bg-[#1a4d4d]/40 backdrop-blur-sm p-8 rounded-xl border border-[#8b956d]/20 hover:border-[#8b956d]/50 transition-all duration-300 hover:scale-105">
              <div className="text-5xl font-bold text-[#8b956d] mb-2 font-['Cinzel']">10+</div>
              <div className="text-lg text-[#c5c9b8] font-semibold">Tools</div>
              <div className="text-sm text-[#b5bca0]">In One Platform</div>
            </div>
            <div className="bg-[#1a4d4d]/40 backdrop-blur-sm p-8 rounded-xl border border-[#8b956d]/20 hover:border-[#8b956d]/50 transition-all duration-300 hover:scale-105">
              <div className="text-5xl font-bold text-[#8b956d] mb-2 font-['Cinzel']">24/7</div>
              <div className="text-lg text-[#c5c9b8] font-semibold">AI Agents</div>
              <div className="text-sm text-[#b5bca0]">Always Working</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
